/* eslint no-param-reassign: ["error", { "props": false }] */

function buildAnchorPrototype(element, binding, id = null) {
	const settings = typeof binding.value === "string" ? { name: binding.value } : binding.value;
	const anchorPrototype = {
		id,
		element,
		...settings,
		...binding.modifiers,
	};

	return anchorPrototype;
}

export default {
	bind(element, binding, vnode) {
		vnode.context.$nextTick(() => {
			const anchorPrototype = buildAnchorPrototype(element, binding, vnode.anchorId);
			const registered = vnode.context.$anchors.register(anchorPrototype);
			vnode.anchorid = anchorPrototype.group ? registered[registered.length - 1].id : registered.id;
		});
	},
	updated(element, binding, vnode) {
		vnode.context.$nextTick(() => {
			const anchorPrototype = buildAnchorPrototype(element, binding, vnode.anchorId);
			vnode.anchorid = vnode.context.$anchors.update(anchorPrototype);
		});
	},
	unbind(element, binding, vnode) {
		if (vnode.anchorId) {
			const anchorPrototype = buildAnchorPrototype(element, binding, vnode.anchorId);
			vnode.context.$nextTick(() => {
				vnode.context.$anchors.unregister({ name: anchorPrototype.name, id: vnode.anchorid });
			});
		}
	},
};



// WEBPACK FOOTER //
// ./src/plugins/vue-anchors-plugin/anchor.directive.js